module.exports = __webpack_public_path__ + "img/trophy-star.b2d69a5f.svg";